import SolutionChallengesI18n from "@/components/landing/shared/SolutionChallengesI18n";
import { Clock, UserX, HelpCircle, MessageSquareOff } from "lucide-react";
const VertriebChallengesSection = () => <SolutionChallengesI18n translationPrefix="vertriebSolution" icons={[Clock, UserX, HelpCircle, MessageSquareOff]} />;
export default VertriebChallengesSection;
